/* eslint-disable sciencepo-rules/require-story*/
/* Inutile de le tester*/
import * as sectionStyles from '../../styles/internal-page/section.module.scss';

import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import Actualite from '../shared/widgets/Actualite';
import Agenda from '../shared/widgets/Agenda';
import ChiffreCle from '../shared/widgets/ChiffreCle';
import Citation from '../shared/widgets/Citation';
import {Embedded} from '../shared/widgets/embedded/Embedded';
import Lien from '../shared/widgets/Lien';
import Marketing from '../shared/widgets/Marketing';
import Twitter from '../shared/widgets/Twitter';
import Youtube from '../shared/widgets/Youtube';
import clsx from 'clsx';
import FocusContent from '../shared/widgets/FocusContent';
import Dispatch from '../shared/widgets/Dispatch';

import ReactComponent from '../shared/widgets/ReactComponent';

const Comps = {
  'CmsPortalComponentWidgetReactComponent': ReactComponent,
  'CmsPortalComponentWidgetTwitter': Twitter,
  'CmsPortalComponentWidgetYoutubeStream': Youtube,
  'CmsPortalComponentWidgetEmbededContent': Embedded,
  'CmsPortalComponentEventEventGuideFilter': Agenda,
  'CmsPortalComponentWidgetLink': Lien,
  'CmsPortalComponentWidgetEvent': Actualite,
  'CmsPortalComponentWidgetNewsItem': Actualite,
  'CmsPortalComponentWidgetFocus': Actualite,
  'CmsPortalComponentWidgetQuote': Citation,
  'CmsPortalComponentWidgetKeyFigures': ChiffreCle,
  'CmsPortalComponentWidgetMarketing': Marketing,
  'CmsPortalComponentWidgetFocusContent': FocusContent,
  'CmsPortalComponentWidgetDispatch': Dispatch,
};

const Section = ({
  elem,
  tweets = [],
  youtubeVideos = [],
  siteURL,
  locale,
}) => {
  const {
    content,
    spacing,
    three_columns,
    title
  } = elem;
  let indexTweet = -1;
  let indexYoutubeVideo = -1;
  let indexEventGuide = -1;
  let playableIndex = 0;
  const [playingVideoIndex, setPlayingVideoIndex] = React.useState(null);

  const sizeSpacing = 21;
  const column = (three_columns) ? 3 : 4;
  const chooseWidget = (elem, column, row) => {
    const Component = Comps[elem.__typename];
    if (elem.__typename === 'CmsPortalComponentWidgetTwitter')
      indexTweet++;
    else if (elem.__typename === 'CmsPortalComponentWidgetYoutubeStream')
      indexYoutubeVideo++;
    else if (elem.__typename === 'CmsPortalComponentEventEventGuideFilter')
      indexEventGuide++;
    if (Component) {
      return (
        <Component
          column={column}
          elem={elem}
          index={playableIndex++}
          indexEventGuide={indexEventGuide}
          indexYoutubeVideo={indexYoutubeVideo}
          locale={locale}
          playingVideoIndex={playingVideoIndex}
          row={row}
          setPlayingVideoIndex={setPlayingVideoIndex}
          siteURL={siteURL}
          tweet={tweets[indexTweet]}
          youtubeVideos={youtubeVideos}
        />
      );
    }
    return null;
  };

  return (
    <div className={sectionStyles.rootSection}>
      <div className={clsx(sectionStyles.rootItem, {[sectionStyles.rootItemNoTitle]: !title})}>
        {title && (
          <div className={sectionStyles.rootTitle}>
            <h2 className={sectionStyles.rootTitleText}>
              {title}
            </h2>
          </div>
        )}
        {content?.length > 0 && (
          <div
            className={sectionStyles.rootContent}
            style={{
              gridTemplateColumns: `repeat(${column}, 1fr)`,
              gap: (spacing) ?
                `${sizeSpacing}px` : '0',
            }}
          >
            {content?.map((block, firstIndex) => {
              if (block?.widget?.content.length > 0) {
                return (
                  <div
                    className={clsx({
                      [sectionStyles.four]: block.col_span === 4,
                      [sectionStyles.three]: block.col_span === 3,
                      [sectionStyles.two]: block.col_span === 2,
                      [sectionStyles.itemFourline]: block.row_span === 4,
                      [sectionStyles.itemThreeline]: block.row_span === 3,
                      [sectionStyles.itemTwoline]: block.row_span === 2,
                      [sectionStyles.item]: block.row_span === 1,
                    })}
                    key={`${firstIndex}`}
                    style={{
                      gridColumn: `span ${block.col_span}`,
                      gridRow: `span ${block.row_span}`,
                    }}
                  >
                    {chooseWidget(block?.widget?.content[0], block.col_span, block.row_span)}
                  </div>
                );
              }
              return <Fragment key={`${firstIndex}`}/>;
            })}
          </div>)}
      </div>
    </div>
  );
};

Section.propTypes = {
  elem: PropTypes.shape({
    content: PropTypes.arrayOf(
      PropTypes.shape({
        widget: PropTypes.shape({
          content: PropTypes.arrayOf(
            PropTypes.shape({
              __typename: PropTypes.string.isRequired,
            })
          ).isRequired,
        }),
        col_span: PropTypes.number,
        row_span: PropTypes.number,
      })
    ),
    spacing: PropTypes.bool,
    three_columns: PropTypes.bool,
    title: PropTypes.string,
    __typename: PropTypes.string,
  }),
  locale: PropTypes.string.isRequired,
  siteURL: PropTypes.string.isRequired,
  tweets: PropTypes.array,
  youtubeVideos: PropTypes.array,
};

export default Section;
